import React from "react";

import Editor from './BColumnistsEditor'
import EditorWrapper from '../../EditorWrapper'

import Columnist from "../../../redesign/components/Columnist";
import EmptyArticle from "../../common/EmptyArticle";

const BColumnists = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.description = settings.description;

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <Columnist
                article={article}
                {...props}
            />
        </div>
    );
};


export default BColumnists;